import dynamic from "next/dynamic";
import Head from "next/head";
import Theme from "/components/Theme";
import People from "/components/organisms/common/People";
import WideCTA from "/components/organisms/common/WideCTA";
import Masonry from "/components/organisms/common/Masonry";
import Hero from "/components/organisms/common/Hero";
import ResponsiveImage from "../components/atoms/image/ResponsiveImage";
import LoudVideoSection from "../components/organisms/common/LoudVideoSection";
import VideoSchema from "../components/organisms/common/VideoSchema";
import BadgeCard from "../components/organisms/badges/BadgeCard";
const AppStorage = dynamic(() => import("../components/AppStorage"));
const TpWidget = dynamic(() => import("../components/atoms/document/TpWidget"));

export async function getStaticProps(ctx) {
  const { locale } = ctx;
  let allData = {};

  // Page Route
  const route = "badges";

  // Fetch
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/root/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/root/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
    },
  };
}
const SecondFold = ({ data }) => {
  return (
    <section className="container grid--default bg-light has-align-middle br-8 md:pt-2 md:pb-5">
      <ResponsiveImage
        src={data.image.src}
        alt={data.image.alt}
        dpi={data.image.prefixes.dpi}
        mobile={data.image.prefixes.mobile}
        wrapClass={`lg:ml-3 lg:my-5 md:m-0`}
      />
      <article className="lg:maxw-lg lg:pr-6 md:pb-2 md:pl-2 md:pr-2 text-left">
        <h2 className="text-lg lg:mb-3 md:mb-2 md:mt-3">{data.title}</h2>
        {data.desc.map((item, index) => {
          return <p key={index} dangerouslySetInnerHTML={{ __html: item }} />;
        })}
      </article>
    </section>
  );
};

export default function Badges({ data, nonce }) {
  const { seo, header, footer, content } = data;
  return (
    <Theme
      header={header}
      footer={footer}
      seo={seo}
      nonce={nonce}
      className="industry-page-with-trust-pilot"
    >
      <AppStorage pageName="Badges Root Page" />
      <Hero data={content.hero} />
      <SecondFold data={content.secondFold} />
      <BadgeCard data={content.badgeCards} />
      <LoudVideoSection
        data={content.loudVideoSection}
        className="lg:pt-10 md:pt-5"
      />
      <Masonry
        data={content.masonry}
        hasTpWidget={true}
        className="lg:mt-20 md:mt-10 lg:mb-20 md:mb-10"
      />
      <People className="lg:mt-20 md:mt-10" />
      <WideCTA data={content.wideCTA} />
      <Head>
        <VideoSchema data={content.loudVideoSection} />
      </Head>
      <TpWidget />
    </Theme>
  );
}
